import * as React from 'react';
import { withRouter } from 'react-router-dom';

// Extracts router props and injects them into a component
export const asPage = <T extends {}>(Component:React.ComponentType<T>) =>
    withRouter((props:any) => 
        <Component {...props.match.params as T} />
    );
